import _axios, {AxiosInstance} from 'axios';
import {AlarmFilterEnum} from "@Safemate/DeviceList/AlarmFilterEnum";
import { TransactionEventFilterEnum } from '../TransactionEnum';

// Setting up axios ------------------------------------------------------------
let axios: AxiosInstance;
const defaultBaseURL = '/ajax';

// For use in safemate proffweb
export const setBaseURL = (baseURL: string) => {
  axios = _axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: true
  });
};

setBaseURL(defaultBaseURL);
// ------------------------------------------------- Finish setting up axios ---

export interface GetTransactions{
    fromDate: number;
    toDate: number;
    deviceId: number;
    filter: TransactionEventFilterEnum[];
}


export const getTransactions = async ({fromDate, toDate, deviceId, filter}: GetTransactions) => {
  const offset = new Date().getTimezoneOffset();
  const url: string = `/transactionLog/txsfordateanddevicetemp/${fromDate}/${toDate}/${offset}/${deviceId}/${filter.length > 0 ? filter : "ALL"}`;
  const response = await axios.get(url);
  return response.data;
}

export const  pollTransactions = async (deviceId: number, toDate: number, filter: TransactionEventFilterEnum[], fromDate: number, latestTxId: number) => {
  const offset = new Date().getTimezoneOffset();
  const url: string = `/transactionLog/moretx/${deviceId}/${toDate}/${offset}/${filter.length > 0 ? filter : "ALL"}/${fromDate}/${latestTxId}`;
  const response = await axios.get(url);
  return response.data;  
};

export const getDevice = async (deviceId: number) => {
  const url: string = `/transactionLog/${deviceId}`;
  const response = await axios.get(url);
  return response.data;
}

export const alarmAnalysis = async (transactionId: number) => {
  const url =  `/alarmanalysis/${transactionId}`;
  const response = await axios.get(url);
  return response.data;
}

export const getNotificationEvents = async (transactionId: number) => {
  const url = `/eventLog/transaction/${transactionId}`;
  const response = await axios.get(url);
  return response.data;
}

export const getBatteryForRange = async (deviId: number) => {
  const url: string = `/transactionLog/batteryfortimerange/${deviId}`;
  const response = await axios.get(url);
  return response.data;
}
export const getSignalForRange = async (deviId: number) => {
  const url: string = `/transactionLog/signalfortimerange/${deviId}`;
  const response = await axios.get(url);
  return response.data;
}

export const logTxLogAccess = async (deviId: number) => {
  const url: string = `/transactionLog/logtxlogaccess/${deviId}`;
  const response = await axios.get(url);
  return response.data;
}